import React from 'react';
import { ConfigProvider, Image } from 'antd';

function ImagePreviewer(props) {
	return (
		<ConfigProvider
			theme={{
				token: {
					zIndexPopupBase: 1301,
				},
				components: {
					Image: {
						zIndexPopup: 1301,
						// colorBgMask: '#ffffff',
						// previewOperationColor: '#000000',
						// previewOperationColorDisabled: 'gray'
					},
				},
			}}
		>
			<Image {...props} />
		</ConfigProvider>
	);
}

export default ImagePreviewer;
